import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Box from 'app/components/v2/components/Box';
import Flex from 'app/components/v2/components/Flex';
import IconButton from 'app/components/v2/components/IconButton';
import Notification from 'app/components/v2/components/Notification';
import Heading4 from 'app/components/v2/components/Text/Heading4';
import Paragraph from 'app/components/v2/components/Text/Paragraph';
import SmallBody from 'app/components/v2/components/Text/SmallBody';
import { formatPhoneNumber } from 'app/utils/lib/string';

import HelpDialogWithIconButton from '..';

// Local Typings
interface Props {
  isLoading?: boolean;
  isPending?: boolean;
  onOpen: () => void;
  relationshipName: string;
  relationshipPhoneNumber?: null | string;
  relationshipPrimaryEmail?: string;
  statusNote: string;
}

// Component Definition
const HeldInvoiceDialog: FC<Props> = props => {
  const { t } = useTranslation('components');

  const invoiceTitle = props.isPending
    ? t('heldInvoiceDialog.invoicePending', 'Invoice pending')
    : t('heldInvoiceDialog.invoiceHeld', 'Invoice held');

  return (
    <HelpDialogWithIconButton
      isLoading={props.isLoading}
      onOpen={props.onOpen}
      title={invoiceTitle}
    >
      <Notification
        marginBottom={4}
        message={props.statusNote}
        severity="error"
        title={invoiceTitle}
      />

      <Paragraph>
        {/* eslint-disable-next-line @stylistic/max-len */}
        {t('heldInvoiecDialog.reachOut', 'Please reach out to {{relationshipName}} with any questions you have.', { relationshipName: props.relationshipName })}
      </Paragraph>
      <Box marginTop={6}>
        <Heading4>
          {t('heldInvoiecDialog.contactInfoLabel', 'Contact Information:')}
        </Heading4>
        <Flex flexWrap="wrap">
          {props.relationshipPhoneNumber && (
            <Flex marginRight={4}>
              <IconButton
                circle
                href={`tel:${props.relationshipPhoneNumber}`}
                iconName="phone"
              />
              <SmallBody>
                {formatPhoneNumber(props.relationshipPhoneNumber)}
              </SmallBody>
            </Flex>
          )}
          {props.relationshipPrimaryEmail && (
            <Flex>
              <IconButton
                circle
                href={`mailto:${props.relationshipPrimaryEmail}`}
                iconName="email"
              />
              <SmallBody>
                {props.relationshipPrimaryEmail}
              </SmallBody>
            </Flex>
          )}
        </Flex>
      </Box>
    </HelpDialogWithIconButton>
  );
};

export default HeldInvoiceDialog;
